import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './GeneralInfo.module.scss';
import {BASE_URL} from '../../../../environment/environment';
import * as urls from '../../../../config/urls';
import {Row, Col} from "react-bootstrap";

class GeneralInfo extends React.Component {
  render() {
    const { advisor = {} } = this.props;

    return (
        <div className={'d-flex flex-column align-items-center p-4'}>
          <div className={`${style.image}`}>
            {
              advisor.avatar ? (
                  <img src={`${BASE_URL}${urls.FILE_BY_UUID}/${advisor.avatar}?size=thumbnails`} alt="profile" />
              ) : (
                  <span className={`${style.no_user} d-flex justify-content-center align-items-center`}>
                                          <i className={'icon-avatar'} />
                                        </span>
              )
            }
          </div>
          <div className={`${style.name}`}>
            <span>{advisor.alias || '---'}</span>
          </div>
          <div className={`${style.code}`}>
            <span>کد مشاور: {advisor.code}</span>
          </div>
          <div className={`${style.email}`}>
            <span>{advisor.email}</span>
          </div>
          <Row className={`${style.phone} d-flex`}>
            <Col xl={6}>
              <a href={`tel:${advisor.mobileNumber}`} type="button" className={`btn btn-secondary btn-sm ${style.search_button} d-flex align-items-center justify-content-between`}>
                {advisor.mobileNumber}
                <i className={'icon-mobile'} />
              </a>
            </Col>
            {
              advisor.realEstate ? (
                  <Col xl={6}>
                    <a href={`tel:${advisor.realEstate.phoneNumber}`} className={`btn btn-primary btn-sm ${style.search_button} d-flex align-items-center justify-content-between`}>
                      {advisor.realEstate.phoneNumber}
                      <i className={'icon-phone'} />
                    </a>
                  </Col>
              ) : (
                  <Col xl={6} />
              )
            }
          </Row>
          <div className={style.description}>
            <span>
              {advisor.summary}
            </span>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GeneralInfo));
